import { CollectionResponse, ContentResponse } from "@authory-packages/core";
import { V3Button } from "../../Button";
import { RightAlignPanel, V3BodyGrey35 } from "../../ReusableStyledComponents";
import { VerticalSpacing } from "../../VerticalSpacing";
import { APPLICATION_ROUTES } from "../../../shared-logic/routes";
import { UnstyledInlineLink } from "../../ReusableStyledComponents/UnstyledLink";
import { V3NoImportTextWrapper } from "../../V3EmptyStateScreen/V3NoImport.styles";
import { AddContentPreviewResult } from "./AddContentPreviewResult";
import { V3ButtonColor } from "../../Button/V3Button.types";
import { getImportContentCopyLabel } from "./AddContent.utils";
import { useAddElementSkeletonTracker } from "../../../context/addElementSkeletonContext";
import { V3Title } from "../../Typography";
import { V3Loader } from "../../Loader";

export interface V3ModalAddContentResultProps {
    items: ContentResponse[];
    collections: CollectionResponse[];
    isPlugin?: boolean;
    isLoading?: boolean;
    onCloseHandler: () => void;
    addOrRemoveItemManuallyFromCollection: (add: boolean, articleSlug: string, collectionSlug: string) => Promise<void>;
    frontendUrl?: string;
}

export const V3ModalAddContentResult = ({
    items,
    isPlugin = false,
    collections,
    isLoading = false,
    onCloseHandler,
    addOrRemoveItemManuallyFromCollection,
    frontendUrl
}: V3ModalAddContentResultProps) => {
    const url =
        items.length > 0 ? `${isPlugin && frontendUrl ? frontendUrl : ""}${APPLICATION_ROUTES.CONTENT}/${items[0].slug}?target=manualadd` : "#";

    const { setAddContentOpen } = useAddElementSkeletonTracker();

    if (!isLoading) {
        return <V3Loader />;
    }

    return (
        <>
            {isPlugin && (
                <VerticalSpacing bottom={14}>
                    <V3Title>Import complete</V3Title>
                </VerticalSpacing>
            )}
            <V3NoImportTextWrapper>
                {!items.length ? (
                    <VerticalSpacing bottom={18}>
                        <V3BodyGrey35>No content items were added.</V3BodyGrey35>
                    </VerticalSpacing>
                ) : (
                    <VerticalSpacing bottom={18}>
                        <V3BodyGrey35>
                            {items.length > 1 ? (
                                <>Great! The following content items have been added:</>
                            ) : (
                                <>Great! The following {getImportContentCopyLabel(items[0].type)} has been added:</>
                            )}
                        </V3BodyGrey35>
                    </VerticalSpacing>
                )}
                {items.map((it) => (
                    <AddContentPreviewResult
                        item={it}
                        toggle={items.length !== 1}
                        key={it.slug}
                        isPlugin={isPlugin}
                        collections={collections}
                        addOrRemoveItemManuallyFromCollection={addOrRemoveItemManuallyFromCollection}
                    />
                ))}
            </V3NoImportTextWrapper>
            <VerticalSpacing top={32}>
                <RightAlignPanel>
                    <div>
                        <V3Button text="Close" onClick={onCloseHandler} autoWidth color={V3ButtonColor.secondary} />
                    </div>
                    {items.length === 1 ? (
                        <div>
                            <UnstyledInlineLink href={url} target={"_blank"}>
                                <V3Button text="Go to content item" onClick={() => {}} autoWidth />
                            </UnstyledInlineLink>
                        </div>
                    ) : (
                        <div>
                            <V3Button
                                text="Add more content"
                                autoWidth
                                onClick={() => {
                                    setAddContentOpen(false);
                                    setTimeout(() => {
                                        setAddContentOpen(true);
                                    }, 100);
                                }}
                            />
                        </div>
                    )}
                </RightAlignPanel>
            </VerticalSpacing>
        </>
    );
};
